import axios from "axios"
import config from "../config"

const { apiServerUrl } = config
const pushNotificationApi = axios.create({
  baseURL: `${apiServerUrl}/pwa/customers/push-notification`,
})

const getAuthConfig = (token, extraConfig = {}) => ({
  ...extraConfig,
  headers: {
    Authorization: `Bearer ${token}`,
    ...extraConfig.headers,
  },
})

export const getPushSubscription = ({ deviceId, token }) =>
  pushNotificationApi
    .get("/subscription", getAuthConfig(token, { params: { deviceId } }))
    .then((response) => response.data)

export const savePushSubscription = ({
  token,
  fcmToken,
  deviceId,
  permissionStatus,
  clientInfo,
}) =>
  pushNotificationApi
    .post(
      "/subscription",
      {
        token: fcmToken,
        deviceId,
        permissionStatus,
        clientInfo,
      },
      getAuthConfig(token)
    )
    .then((response) => response.data)

export const unsubscribePushSubscription = ({
  token,
  deviceId,
  permissionStatus,
}) =>
  pushNotificationApi
    .post(
      "/unsubscribe",
      { deviceId, permissionStatus },
      getAuthConfig(token)
    )
    .then((response) => response.data)

export const logPushSubscriptionError = ({ token, error, context }) => {
  if (!token) return Promise.resolve()

  return pushNotificationApi
    .post(
      "/log-error",
      {
        context,
        name: error?.name || "",
        message: error?.message || String(error || ""),
        stack: error?.stack || "",
      },
      getAuthConfig(token)
    )
    .catch(() => undefined)
}
